import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import jwt_decode from 'jwt-decode';

import { IoMdArrowBack } from 'react-icons/io';

import { toast } from 'react-toastify';

import { Switch } from 'antd';

import Breadcumbs from '~/components/Breadcumbs';

import history from '~/services/history';

import { signInSuccess } from '~/store/modules/auth/actions';

import api from '~/services/api';

import {
  PageTitle,
  BoxContent,
  Container,
  Content,
  Row,
  Col,
  Label,
  ButtonBox,
  SwitchButton,
} from './style';

const TermoDeAceite = () => {
  return (
    <>
      <Breadcumbs path="/" pathTitle="Termo de Aceite" />
      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <div>
          <span>Termo de Aceite</span>
        </div>
      </PageTitle>
      <Termo />
    </>
  );
};

export default TermoDeAceite;

export const Termo = props => {
  const dispatch = useDispatch();

  const authState = useSelector(state => state.auth);

  const { systemConfig, token } = useSelector(state => state.auth);

  const { usuarioAssinouTermo } = systemConfig;

  const decodedToken = jwt_decode(token.split(' ')[1]);

  const { name } = decodedToken;

  const cpf = sessionStorage
    .getItem('cpf')
    .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

  const getSystemconfig = async () => {
    try {
      const newSystemConfig = {
        ...authState?.systemConfig,
        usuarioAssinouTermo: true,
      };

      dispatch(
        signInSuccess({
          ...authState,
          systemConfig: newSystemConfig,
        })
      );
    } catch (error) {
      //
    }
  };

  const saveTermos = async () => {
    try {
      await api.post(
        '/usuario-termo-responsabilidade',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: String(token),
          },
        }
      );

      toast.success('Termo de responsabilidade aceito com sucesso!', {
        autoClose: 5000,
      });

      getSystemconfig();
      if (!window?.location?.pathname?.includes('minha-conta')) {
        history.push('/');
      }
    } catch (error) {
      console.log('error', error);

      toast.error('Erro ao assinar termo de responsabilidade.', {
        autoClose: 5000,
      });
    }
  };

  const [termoAceito, setTermoAceito] = useState(!usuarioAssinouTermo);

  return (
    <BoxContent>
      <Container>
        <Content>
          <Row>
            <h4>
              TERMO DE RESPONSABILIDADE PARA O USO DE SISTEMAS DE INFORMAÇÃO DE
              PROPRIEDADE OU CUSTODIADOS PELA AGÊNCIA NACIONAL DE SAÚDE
              SUPLEMENTAR
            </h4>
          </Row>
          <Row>
            <p>
              Eu, <span>{name.toUpperCase()}</span>, inscrito no CPF/MF n°{' '}
              <span>{cpf}</span> declaro estar ciente das minhas
              responsabilidades ao utilizar sistemas de informação de
              propriedade ou custodiados pela Agência Nacional de Saúde
              Suplementar e me comprometo a cumprir as determinações constantes
              desse termo de responsabilidade, a saber:{' '}
            </p>
          </Row>
          <Row>
            <ul>
              <li>
                I. Utilizar os dados e informações dos sistemas informatizados
                da Agência Nacional de Saúde Suplementar (ANS) com a necessária
                cautela a fim de evitar sua exposição, sejam estes, exibidos em
                tela, impressos ou gravados em quaisquer meios ou mídias, a fim
                de evitar que deles venham a tomar ciência pessoas não
                autorizadas.
              </li>
              <li>
                II. Não revelar, fato ou informação de qualquer natureza obtida
                dos sistemas informatizados da ANS de que tenha conhecimento por
                força de minhas atribuições, salvo em decorrência de decisão
                competente na esfera legal ou judicial, bem como de autoridade
                superior.
              </li>
              <li>III. Alterar minha senha sempre que obrigatório.</li>
              <li>
                IV. Alterar a senha imediatamente e informar à ANS sempre que
                exista a suposição de descoberta da mesma por terceiros.
              </li>
              <li>
                V. Solicitar o bloqueio temporário do meu login, em caso de
                perda, roubo ou extravio do meu certificado digital até que os
                procedimentos para revogação e emissão de um novo certificado
                sejam concluídos.
              </li>
              <li>
                VI. Respeitar as normas de segurança e restrições de sistema
                impostas pelos sistemas de segurança implantados na ANS.
              </li>
              <li>
                VII. Observar e cumprir as boas práticas de segurança da
                informação, de acordo com as normas relativas à matéria, bem
                como este Termo de Responsabilidade.
              </li>
              <li>
                VIII. Responder, em todas as instâncias, pelas consequências das
                ações ou omissões de minha parte.
              </li>
            </ul>
          </Row>

          <Row>
            <p>
              Declaro, ainda, estar plenamente esclarecido e consciente que:
            </p>
          </Row>
          <Row>
            <ul>
              <li>
                a. É de minha responsabilidade assegurar a exatidão dos dados e
                informações por mim inseridas nos sistemas da ANS, devendo
                comunicar por escrito à minha chefia imediata quaisquer indícios
                ou possibilidades de irregularidades, de desvios ou falhas
                identificadas nos sistemas, sendo proibida a exploração de
                falhas ou vulnerabilidades porventura existentes.
              </li>
              <li>
                b. Sou responsável por todas as operações realizadas sob minhas
                credenciais de acesso.
              </li>
              <li>
                c. As senhas de acesso aos sistemas informatizados da ANS são de
                uso pessoal e intransferível, sendo terminantemente proibida sua
                divulgação a terceiros.
              </li>
              <li>
                d. É passível de responsabilização criminal e civil o mau uso
                dos dados obtidos dos sistemas aos quais tenho acesso, bem como
                a facilitação de inserção ou inserção de dados falsos, alteração
                ou exclusão indevida de dados corretos dos sistemas ou bancos de
                dados da Administração Pública, com a finalidade de obter
                vantagem indevida para si ou para outrem, bem como a modificação
                ou alteração indevida do sistema de informações ou programa de
                informática sem autorização de autoridade competente.
              </li>
            </ul>
          </Row>
          <Row>
            <Col>
              <Label>Aceito o termo de responsabilidade</Label>
              <SwitchButton>
                <Switch
                  onClick={() => setTermoAceito(!termoAceito)}
                  disabled={usuarioAssinouTermo}
                />
              </SwitchButton>
            </Col>
          </Row>

          <ButtonBox>
            <button
              type="button"
              disabled={termoAceito || usuarioAssinouTermo}
              onClick={() => saveTermos()}
            >
              Salvar
            </button>
          </ButtonBox>
        </Content>
      </Container>
    </BoxContent>
  );
};
